// Screen Wake Lock API for Cooking Mode
document.addEventListener('DOMContentLoaded', function() {
  let wakeLock = null;
  const toggleButton = document.getElementById('cooking-mode-toggle');
  const statusSpan = document.getElementById('cooking-mode-status');
  
  // Check if elements exist (in case script is loaded on pages without cooking mode)
  if (!toggleButton || !statusSpan) {
    return;
  }
  
  // Check if Screen Wake Lock API is supported
  const isWakeLockSupported = 'wakeLock' in navigator;
  
  if (!isWakeLockSupported) {
    statusSpan.textContent = '(Not supported in this browser)';
    toggleButton.disabled = true;
    toggleButton.style.opacity = '0.5';
    return;
  }
  
  // Request wake lock
  async function requestWakeLock() {
    try {
      wakeLock = await navigator.wakeLock.request('screen');
      console.log('Screen wake lock activated');
      statusSpan.textContent = 'Screen will stay on';
      
      // Listen for wake lock release (e.g., when tab becomes inactive)
      wakeLock.addEventListener('release', () => {
        console.log('Screen wake lock released');
        updateToggleState(false);
      });
      
      return true;
    } catch (err) {
      console.error('Failed to request wake lock:', err);
      statusSpan.textContent = 'Failed to activate';
      return false;
    }
  }
  
  // Release wake lock
  async function releaseWakeLock() {
    if (wakeLock) {
      try {
        await wakeLock.release();
        wakeLock = null;
        console.log('Screen wake lock manually released');
        statusSpan.textContent = '';
      } catch (err) {
        console.error('Failed to release wake lock:', err);
      }
    }
  }
  
  // Update toggle visual state
  function updateToggleState(isActive) {
    toggleButton.setAttribute('data-active', isActive.toString());
    if (!isActive) {
      statusSpan.textContent = '';
    }
  }
  
  // Toggle button click handler
  toggleButton.addEventListener('click', async function() {
    const isCurrentlyActive = toggleButton.getAttribute('data-active') === 'true';
    
    if (isCurrentlyActive) {
      // Turn off cooking mode
      await releaseWakeLock();
      updateToggleState(false);
    } else {
      // Turn on cooking mode
      const success = await requestWakeLock();
      updateToggleState(success);
    }
  });
  
  // Handle page visibility change - reacquire wake lock when page becomes visible again
  document.addEventListener('visibilitychange', async () => {
    if (wakeLock !== null && document.visibilityState === 'visible') {
      const wasActive = toggleButton.getAttribute('data-active') === 'true';
      if (wasActive) {
        await requestWakeLock();
      }
    }
  });
  
  // Clean up when page is about to unload
  window.addEventListener('beforeunload', () => {
    if (wakeLock) {
      wakeLock.release();
    }
  });
});